var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTravel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.196 41.356A5 5 0 0017.01 45h19a5 5 0 004.815-3.65l2.097-7.483a1.77 1.77 0 00-.1-1.3 1.65 1.65 0 00-.99-.834l-2.113-.7v-7.7c0-1.833-1.486-3.333-3.301-3.333h-4.953v-5H21.56v5h-4.952c-1.816 0-3.302 1.5-3.302 3.333v7.7l-2.13.7a1.65 1.65 0 00-.99.834c-.198.4-.247.866-.099 1.3l2.11 7.489zm4.411-18.023h19.81v6.617l-9.905-3.283-9.905 3.283v-6.617zM49.134 20.5a1 1 0 011.732 0l2.598 4.5a1 1 0 01-.866 1.5h-5.196a1 1 0 01-.866-1.5l2.598-4.5zm-.02 17.813a1 1 0 001.771 0l2.676-5.098a1 1 0 00-.885-1.465h-5.352a1 1 0 00-.885 1.465l2.676 5.098z",
    fill: "#E3B05F"
  })));
}

export default SvgTravel;